(function () {
  'use strict';
  // One controller is bound to each rendered product section.
  var DOCUMENT_BOUND = '__woodwrightsMaterialSelectorBound';
  var ROOT_BOUND = '__woodwrightsMaterialSelectorRootBound';

  function selected(root) {
    var values = {};
    root.querySelectorAll('.variants-modal .sample.active').forEach(function (sample) {
      values[Number(sample.dataset.optionPosition)] = (sample.dataset.optionValue || '').trim();
    });
    root.querySelectorAll('[data-option-role="inline"] .variant-option__content--main .variant-option__value').forEach(function (value) {
      values[Number(value.dataset.optionPosition)] = (value.dataset.optionValue || '').trim();
    });
    return values;
  }

  function matching(variants, options) {
    var positions = Object.keys(options);
    return variants.find(function (variant) {
      return positions.every(function (position) {
        return String(variant.options[Number(position)]).trim() === options[position];
      });
    });
  }

  function activeByVariant(elements, attribute, variantId) {
    elements.forEach(function (el) {
      el.classList.toggle('active', el.getAttribute(attribute) === String(variantId));
    });
  }

  function updateSizes(root, sizes, variant) {
    var entry = sizes.find(function (size) {
      return String(size.variant_id) === String(variant.id);
    });

    if (entry) {
      ['height', 'width', 'depth'].forEach(function (dimension) {
        var selector = '#product-modal-' + dimension;
        var el = root.querySelector(selector) || document.querySelector(selector);
        if (!el) return;

        var value = entry[dimension] == null ? '' : String(entry[dimension]).trim();
        el.closest('.product-modal-dim__row').classList.toggle('is-empty', value === '');
        el.textContent = value && value.indexOf('mm') === -1 ? value + 'mm' : value;
      });
    }

    document.querySelectorAll('#pdp-info-modal [data-variant-dimensions]').forEach(function (el) {
      el.hidden = String(el.dataset.variantDimensions) !== String(variant.id);
    });
  }

  function applyVariant(root, data, sizes, variant) {
    var input = root.querySelector('input.variant-id');
    input.value = variant.id;
    updateSizes(root, sizes, variant);

    activeByVariant(root.querySelectorAll('.product-main__price-row'), 'data-variant-id', variant.id);

    // Product details can live in a sibling section or a modal moved under
    // <body>, so these targets cannot be scoped to this root.
    activeByVariant(document.querySelectorAll('.product-details__downloads-wrapper'), 'data-variant-id', variant.id);
    activeByVariant(document.querySelectorAll('.product-details__drawings'), 'data-variant', variant.id);

    var gallery = root.querySelector('.variants-modal__gallery .swiper');
    if (gallery && gallery.swiper) gallery.swiper.slideTo(data.variants.indexOf(variant));

    var url = new URL(window.location.href);
    url.searchParams.set('variant', variant.id);
    window.history.replaceState({}, '', url.pathname + url.search + url.hash);

    $(input).trigger('change');
    document.dispatchEvent(new CustomEvent('variantChanged', { detail: { variantId: variant.id } }));
  }

  // 'available' buyable | 'soldout' real variant, not buyable | 'missing' no such variant.
  // A disabled input is not submitted, so 'missing' cannot post the previous variant.
  function setPurchaseState(root, state) {
    var input = root.querySelector('input.variant-id');
    if (input) {
      input.disabled = state === 'missing';
      if (state === 'missing') input.value = '';
    }

    var atc = root.querySelector('.product-form__atc');
    if (!atc) return;
    atc.disabled = state !== 'available';
    atc.classList.toggle('disabled', state !== 'available');

    var label = atc.dataset['atcLabel' + state.charAt(0).toUpperCase() + state.slice(1)];
    if (label) atc.textContent = label;
  }

  function refresh(root, data, sizes) {
    var options = selected(root);
    var complete = Object.keys(options).length === data.variants[0].options.length;
    var variant = complete ? matching(data.variants, options) : undefined;

    if (!variant) {
      setPurchaseState(root, 'missing');
      activeByVariant(root.querySelectorAll('.product-main__price-row'), 'data-variant-id', null);
      return;
    }

    setPurchaseState(root, variant.available ? 'available' : 'soldout');
    applyVariant(root, data, sizes, variant);
  }

  function closeInline(root, except) {
    root.querySelectorAll('[data-option-role="inline"]').forEach(function (option) {
      if (option !== except) {
        option.classList.remove('active');
        $(option).find('.variant-option__items').slideUp();
      }
    });
  }

  // Owned by the section controller so a theme-editor section reload rebuilds it.
  // `el.swiper` is Swiper's own instance marker, so this cannot stack instances.
  function initGallery(root, data) {
    var el = root.querySelector('.variants-modal__gallery .swiper');
    if (!el || el.swiper || typeof window.Swiper !== 'function') return;

    var input = root.querySelector('input.variant-id');
    var start = data.variants.findIndex(function (variant) {
      return String(variant.id) === (input ? input.value : '');
    });
    var contents = root.querySelectorAll('.variants-modal__content');

    var gallery = new window.Swiper(el, {
      effect: 'fade',
      fadeEffect: { crossFade: true },
      initialSlide: start > -1 ? start : 0,
      pagination: {
        el: el.querySelector('.swiper-pagination'),
        clickable: true,
        renderBullet: function (index, className) {
          return '<span class="' + className + '">' + String(index + 1).padStart(2, '0') + '</span>';
        },
      },
    });

    gallery.on('slideChange', function () {
      var id = gallery.slides[gallery.activeIndex].getAttribute('data-variant-id');
      contents.forEach(function (content) {
        content.classList.toggle('active', content.getAttribute('data-id') === id);
      });
    });
  }

  function setTab(root, name) {
    var modal = root.querySelector('.variants-modal');
    modal.querySelectorAll('[data-tab]').forEach(function (el) {
      el.classList.toggle('active', el.dataset.tab === name);
    });
    Array.prototype.forEach.call(modal.classList, function (name) {
      if (name.indexOf('variants-modal--') === 0) modal.classList.remove(name);
    });
    modal.classList.add('variants-modal--' + name);

    // The curated strip and its "free samples" message only apply to tabs that
    // actually have curated swatches; mirrors the CSS reveal condition.
    var swatches = modal.querySelector('.variants-modal__swatches');
    var slider = swatches && swatches.querySelector('.product-materials__slider--' + name);
    modal.classList.toggle(
      'variants-modal--has-curated',
      !!(slider && slider.querySelector('.swiper-slide') &&
         swatches.classList.contains('variants-modal__swatches--' + name))
    );
    var link = modal.querySelector('.variants-modal__actions .underlined-link');
    var tab = modal.querySelector('.variants-modal__tabs .tab[data-tab="' + name + '"]');
    if (tab) link.querySelector('.link-text').textContent = tab.textContent.trim();
    link.setAttribute('href', '/pages/materials#' + name);
  }

  function closeModal(root) {
    root.querySelector('.variants-modal').classList.remove('active');
    document.body.classList.remove('variants-modal--open');
    root.querySelectorAll('.materials-overlay').forEach(function (overlay) {
      overlay.classList.remove('active');
    });
  }

  function bind(root) {
    if (!root || root[ROOT_BOUND]) return;

    var data;
    try {
      data = JSON.parse(root.querySelector('#product-json').textContent);
    } catch (error) {
      console.error('material-selector: could not parse #product-json', error);
      return;
    }

    if (!data || data.variants.length < 2) return;
    root[ROOT_BOUND] = true;

    var sizes = [];
    var sizesJson = root.querySelector('#product-variant-metafield-sizes');
    if (sizesJson) {
      try {
        sizes = JSON.parse(sizesJson.textContent);
      } catch (error) {
        console.error('material-selector: could not parse variant sizes', error);
      }
    }

    initGallery(root, data);

    // Product materials is a legacy external component mirrored into this modal.
    var swatches = root.querySelector('.variants-modal__swatches');
    var productMaterials = document.querySelector('.product-materials');
    if (swatches && productMaterials && !swatches.children.length) {
      swatches.innerHTML = productMaterials.innerHTML;
    }
    root.addEventListener('click', function (event) {
      var item = event.target.closest('.variant-option__item');
      if (item && root.contains(item)) {
        var option = item.closest('[data-option-role="inline"]');
        option.querySelector('.variant-option__content--main').innerHTML = item.querySelector('.variant-option__content').innerHTML;
        Array.prototype.forEach.call(item.parentNode.children, function (sibling) {
          sibling.style.display = sibling === item ? 'none' : '';
        });
        option.classList.remove('active');
        closeInline(root);
        refresh(root, data, sizes);
        return;
      }

      var inline = event.target.closest('[data-option-role="inline"]');
      if (inline && root.contains(inline) && inline.querySelector('.variant-option__items')) {
        closeInline(root, inline);
        inline.classList.toggle('active');
        $(inline).find('.variant-option__items').slideToggle();
        return;
      }

      var sample = event.target.closest('.variants-modal .sample');
      if (sample && root.contains(sample)) {
        var panel = sample.closest('.variants-modal__tab-content');
        panel.querySelectorAll('.sample').forEach(function (el) {
          el.classList.remove('active');
        });
        sample.classList.add('active');

        var tile = root.querySelector('[data-variant-option][data-tab="' + panel.dataset.tab + '"]');
        var value = sample.dataset.optionValue || '';
        var label = tile.querySelector('.variant-option__value');
        label.textContent = value;
        label.dataset.optionValue = value;

        var current = tile.querySelector('.variant-option__media');
        var image = sample.querySelector('.sample__image img');
        var media = document.createElement(image ? 'img' : 'span');
        media.className = image
          ? 'variant-option__media'
          : 'variant-option__media variant-option__media--empty';
        if (image) {
          media.src = image.src;
          media.alt = '';
          media.loading = 'lazy';
        } else {
          media.setAttribute('aria-hidden', 'true');
        }
        current.replaceWith(media);
        refresh(root, data, sizes);
        return;
      }

      var opener = event.target.closest('.variants-modal__open');
      if (opener && root.contains(opener)) {
        event.preventDefault();
        document.dispatchEvent(new CustomEvent('theme:modal:close', {
          bubbles: true,
          detail: { source: 'variants-modal' },
        }));
        setTab(root, opener.dataset.tab);
        root.querySelector('.variants-modal').classList.add('active');
        document.body.classList.add('variants-modal--open');
        root.querySelectorAll('.materials-overlay').forEach(function (overlay) {
          overlay.classList.add('active');
        });
        return;
      }

      var tab = event.target.closest('.variants-modal .tab');
      if (tab && root.contains(tab)) {
        event.preventDefault();
        setTab(root, tab.dataset.tab);
        return;
      }

      var close = event.target.closest('.variants-modal__close, .product-materials__close, .materials-overlay');
      if (close && root.contains(close)) {
        closeModal(root);
        return;
      }

      closeInline(root);
    });
  }

  function init(scope) {
    scope.querySelectorAll('.variant-bar').forEach(function (bar) {
      bind(bar.closest('[id^="shopify-section-"]'));
    });
  }

  if (!document[DOCUMENT_BOUND]) {
    document[DOCUMENT_BOUND] = true;
    document.addEventListener('shopify:section:load', function (event) {
      init(event.target);
    });

    // Detecting a click outside the section necessarily crosses the component
    // boundary. Bound once and resolved against live nodes, so section
    // replacement cannot leave stale roots behind.
    document.addEventListener('click', function (event) {
      if (event.target.closest('[data-option-role="inline"]')) return;
      document.querySelectorAll('.variant-bar').forEach(function (bar) {
        var root = bar.closest('[id^="shopify-section-"]');
        if (root) closeInline(root);
      });
    });
  }

  init(document);
})();
